import React, { Component } from 'react';
import { TouchableOpacity, View } from 'react-native';

import { isFunction as _isFunction } from 'lodash';
import PropTypes from 'prop-types';

import { Icon, VFScreen, VFText, VFBanner } from '@vfgroup-oneplatform/foundation/Components';
import { withTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';
import ContentManager from '@vfgroup-oneplatform/foundation/ContentManager';

import { getThemeImages } from '../../../Themes';
import { DeviceUpgradeHeader } from '../../Components';
import { PurchaseSteps } from '../../Containers';

import styles from './Purchase.Styles';

class Purchase extends Component {
  constructor(props) {
    super(props);
    this.state = {
      header: {
        isVisible: true,
      },
      isCostBreakDownModalVisible: false,
    };
  }

  onCloseCostBreakDownModal = () => {
    this.setState({ isCostBreakDownModalVisible: false });
  };

  onOpenCostBreakDownModal = () => {
    this.setState({
      isCostBreakDownModalVisible: true,
    });
  };

  onCostBreakDownPrimaryBtnPress = () => {
    const { onCostBreakDownPrimaryButtonPress } = this.props;
    this.setState({ isCostBreakDownModalVisible: false });
    onCostBreakDownPrimaryButtonPress();
  };
  getUpfront = () => {
    const { header } = this.state;

    return header?.selectedDevice?.price?.upfront ?? 0;
  };
  getMonthly = () => {
    const { header } = this.state;
    let base = header.selectedDevice?.price?.recurringCharge ?? 0;
    if (header.selectedPlan) {
      base += +header.selectedPlan.price;
    }
    return base;
  };

  updateHeader = values => {
    this.setState(prev => {
      return {
        ...prev,
        header: { ...prev.header, ...values },
      };
    });
  };

  resetHeader = () => {
    this.setState(prev => {
      return {
        ...prev,
        header: {},
      };
    });
  };

  renderSubHeaderTitle = () => {
    const { header } = this.state;
    if (!header.selectedDevice) {
      return null;
    }
    const recurring = this.props.isCurrencyFirst
      ? header.selectedDevice.price.currency + this.getMonthly()
      : this.getMonthly() + header.selectedDevice.price.currency;
    const upfront = this.props.isCurrencyFirst
      ? header.selectedDevice.price.currency + this.getUpfront()
      : this.getUpfront() + header.selectedDevice.price.currency;
    return (
      <DeviceUpgradeHeader
        phoneName={header.selectedDevice.name}
        recurring={recurring}
        upfront={upfront}
      />
    );
  };

  renderDescriptionInfo = () => {
    const { header } = this.state;
    const { theme } = this.props;
    if (!header.selectedDevice || header.isCostBreakDownButtonVisible === false) {
      return null;
    }
    const Images = getThemeImages(theme.name);
    return (
      <View style={styles.subHeaderContainer}>
        <TouchableOpacity onPress={this.onOpenCostBreakDownModal} style={styles.costBreakDownBtn}>
          <VFText
            style={styles.costBreakDownBtnText}
            i18nKey={'device_upgrade_header_cost_breakdown_button_title'}
            type="tertiary"
          />
          <Icon
            name={Images.ic_list}
            type="image"
            size={22}
            style={styles.costBreakDownBtnIcon(theme)}
          />
        </TouchableOpacity>
      </View>
    );
  };
  renderCostBreakDownFooter = () => {
    const { onCostBreakDownPrimaryButtonPress, onCostBreakDownSecondaryButtonPress } = this.props;

    return _isFunction(onCostBreakDownPrimaryButtonPress) &&
      _isFunction(onCostBreakDownSecondaryButtonPress) ? (
      <VFBanner
        type="primary"
        containerViewStyle={styles.costBreakDownFooter}
        withSecondaryButton={true}
        withCloseButton={false}
        primaryButtonTitle={'device_upgrade_cost_breakdown_modal_footer_primary_button_title'}
        secondaryButtonTitle={'device_upgrade_cost_breakdown_modal_footer_secondary_button_title'}
        title="device_upgrade_cost_breakdown_modal_footer_title"
        description="device_upgrade_cost_breakdown_modal_footer_description"
        onPrimaryButtonPress={this.onCostBreakDownPrimaryBtnPress}
        onSecondaryButtonPress={onCostBreakDownSecondaryButtonPress}
      />
    ) : null;
  };
  render() {
    const { header, isCostBreakDownModalVisible } = this.state;
    const { theme, onClose, onBack, vfScreen, ...props } = this.props;

    return (
      <VFScreen
        title="device_upgrade_screen_title"
        onClose={onClose}
        showBack
        onBack={onBack}
        {...vfScreen}
        withSubHeader={header.selectedDevice}
        renderSubHeaderTitle={this.renderSubHeaderTitle}
        subHeaderDescription={
          header.selectedDevice
            ? `${
                header.selectedDevice.price.recurringChargePeriodDuration
              } ${ContentManager.translate('device_upgrade_header_contract_type_text')}`
            : null
        }
        renderDescriptionInfo={this.renderDescriptionInfo}
        withHeaderSpace
      >
        <PurchaseSteps
          {...props}
          renderCostBreakDownFooter={this.renderCostBreakDownFooter}
          stepperViewStyle={styles.stepperViewStyle}
          setHeader={this.updateHeader}
          resetHeader={this.resetHeader}
          isCostBreakDownModalVisible={isCostBreakDownModalVisible}
          onCloseCostBreakDownModal={this.onCloseCostBreakDownModal}
        />
      </VFScreen>
    );
  }
}

Purchase.defaultProps = {
  vfScreen: {},
  theme: LightThemeColors,
  isCurrencyFirst: false,
};

Purchase.propTypes = {
  onClose: PropTypes.func,
  onBack: PropTypes.func,
  vfScreen: PropTypes.object,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  onCostBreakDownPrimaryButtonPress: PropTypes.func,
  onCostBreakDownSecondaryButtonPress: PropTypes.func,
  isCurrencyFirst: PropTypes.bool,
};

export default withTheme(Purchase);
